export default "__VITE_ASSET__ChgrmPOP__"